export default "__VITE_ASSET__Dsbu2zCV__"